import React ,{useState} from 'react';
import styled from 'styled-components';
import MypageTopGuest from 'components/fixbar/MypageTopGuest';
import ModalPath from 'components/modal/ModalPath';  
import { Link } from "react-router-dom";



export default function MyPageMainGuestLayout() {
    const [showModal,setShowModal]=useState(false)
    return (
        <Mypageinner>
            <MypageTopGuest 
              title={"마이페이지"} 
              borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}
              setShowModal={setShowModal}
            />
            <Inner>
              <Subtit>로그인을 해주세요 :)</Subtit>
              <LoginBtn to={`/social`} >로그인하기</LoginBtn>
              <CustommerServiceBtnBlock>
                <CustommerServiceBtn target='_blank' href={'http://pf.kakao.com/_gmtJs/chat'}>문의하기</CustommerServiceBtn>
              </CustommerServiceBtnBlock>
            </Inner> 
            <ModalPath 
                setShowModal={setShowModal}
                showModal={showModal}
                subtitle={"로그인이 필요해요"} 
                // submitClick={afterShow}
            />
        </Mypageinner>
    )
}


const Mypageinner = styled.div`
    height: 100%;
    overflow-y: scroll;
    padding : calc(100vw*(51/375)) 0 0;
`
const Subtit = styled.p`
    font-size: 16px;
    font-weight: 500;
    line-height: 2.48;
    color: #989898;
    padding-bottom: calc(100vw*(29/375));
`
const Inner = styled.div`
    padding : calc(100vw*(14/375)) calc(100vw*(18/375));
`
const LoginBtn = styled(Link)`
    width: calc(100vw*(339/375));
    height: calc(100vw*(48/375));
    border-radius: calc(100vw*(5/375));
    background-color: #ffcf19;
    font-size: 16px;
    font-weight: 500;
    line-height: calc(100vw*(48/375));
    color: #121212;
    text-align: center;
`

const CustommerServiceBtnBlock = styled.div`
    text-align: center;
`;

const CustommerServiceBtn = styled.a`
    margin-top: calc(100vw * (17 / 375));
    font-size: calc(100vw * (14 / 375));
    border-bottom: 1px solid #4E4E4E;
    color: #4E4E4E;
`;